import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";
const initialState = {
  data: [],
  loading: false,
  error: null,
};

const Payment = createSlice({
  name: "payment",
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    updatePayment: (state, action) => {
      const index = state.data.findIndex((r) => r._id === action.payload._id);
      if (index !== -1) {
        state.data[index] = action.payload;
      }
    },
    removePayment: (state, action) => {
      state.data = (state.data || []).filter((r) => r._id !== action.payload);
    },
    addPayment: (state, action) => {
      // insert new payment method at start
      state.data = [action.payload, ...(state.data || [])];
    },
    fetchFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});

// Actions
export const {
  fetchStart,
  fetchFailure,
  fetchSuccess,
  updatePayment,
  removePayment,
  addPayment,
} = Payment.actions;

// Create payment method
export const CreatePaymentMethod = (payload) => async (dispatch) => {
  try {
    const res = await axios.post("/private/paymentmethods", payload);
    if (res && res.data) {
      // add locally and stop loading
      dispatch(addPayment(res.data));
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

// Update payment method
export const UpdatePaymentMethod = (id, payload) => async (dispatch) => {
  try {
    const res = await axios.put(`/private/paymentmethods/${id}`, payload);
    if (res && res.data) {
      dispatch(updatePayment(res.data));
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

// Delete payment method
export const DeletePaymentMethod = (id) => async (dispatch) => {
  try {
    const res = await axios.delete(`/private/paymentmethods/${id}`);
    if (res && res.data) {
      dispatch(removePayment(id));
      toast.success("Payment method deleted");
    }
    return res.data;
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    return null;
  }
};

export const GetPaymentMethods = () => async (dispatch) => {
  try {
    dispatch(fetchStart());

    const res = await axios.get("/private/paymentmethods");

    if (res.data) {
      dispatch(fetchSuccess(res.data));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    dispatch(fetchFailure(errorMessage));
  }
};

export const UploadPicture = (file) => async (dispatch) => {
  try {
    const formData = new FormData();
    formData.append("file", file);

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = await axios.post("/private/singleimage", formData, config);
    return response.data;
  } catch (err) {
    const errorMessage = err?.response?.data?.message || String(err);
    toast.error(errorMessage);
    return null;
  }
};

export default Payment.reducer;
